import { monthlyRank } from "@/mocks/gua";
import SectionTitle from "./SectionTitle";

export default function Monthly() {
  return (
    <section id="monthly" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <SectionTitle
            eyebrow="本月盘点"
            title="这个月，值得复盘的五件事"
            desc="月度收尾，把整月零散的热点串成一条线，看清最近大家到底在关注什么、风向往哪走。"
            align="left"
          />
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1.5 text-xs font-bold text-primary-800">
            <i className="ri-pie-chart-2-line" aria-hidden="true" />
            2026 年 8 月重点
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="flex flex-col gap-3">
            {monthlyRank.slice(0, 3).map((item) => (
              <MonthCard key={item.id} item={item} />
            ))}
          </div>
          <div className="flex flex-col gap-3">
            {monthlyRank.slice(3).map((item) => (
              <MonthCard key={item.id} item={item} />
            ))}
            <div className="flex flex-1 flex-col items-start justify-center gap-2 rounded-2xl border border-dashed border-accent-300 bg-accent-50/60 p-5">
              <i className="ri-lightbulb-flash-fill text-xl text-accent-600" aria-hidden="true" />
              <p className="text-sm font-semibold text-accent-900">看趋势小贴士</p>
              <p className="text-xs leading-relaxed text-accent-800/80">
                本月“内容情绪价值”是绝对主线：剧集讲治愈、综艺看意外、线下找氛围。下个月关注点大概率仍围绕“体验感”做文章。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function MonthCard({ item }: { item: (typeof monthlyRank)[number] }) {
  return (
    <article className="group flex items-center gap-4 rounded-2xl bg-background-100 p-4 transition-colors hover:bg-background-200/60">
      <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-primary-500 font-heading text-xl font-black text-white">
        {String(item.rank).padStart(2, "0")}
      </div>
      <div className="flex flex-1 flex-col gap-1.5">
        <div className="flex items-center gap-2">
          <span className="whitespace-nowrap rounded-full bg-white px-2 py-0.5 text-[11px] font-bold text-foreground-700">
            {item.tag}
          </span>
          <span className="whitespace-nowrap text-[11px] font-semibold text-primary-600">{item.heat}</span>
        </div>
        <h3 className="font-heading text-sm font-black leading-snug text-foreground-900 md:text-base">{item.title}</h3>
        <p className="text-xs leading-relaxed text-foreground-600">{item.summary}</p>
      </div>
      <i className="ri-arrow-right-line text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" aria-hidden="true" />
    </article>
  );
}